function isDeepEqual(first, second) {
	/*
	 * If first and second are the same type and have the same value
	 * Useful if strings or other primitive types are compared
	 */
	if (first === second) {
		return true;
	}

	// Try a quick compare by seeing if the length of properties are the same
	let firstProps = Object.getOwnPropertyNames(first);
	let secondProps = Object.getOwnPropertyNames(second);

	// Check different amount of properties
	if (firstProps.length !== secondProps.length) {
		return false;
	}

	// Go through properties of first object
	for (let i = 0; i < firstProps.length; i++) {
		let prop = firstProps[i];
		// Check the type of property to perform different comparisons
		switch (typeof first[prop]) {
			// If it is an object, descend for deep compare
			case 'object':
				if (!isDeepEqual(first[prop], second[prop])) {
					return false;
				}
				break;
			case 'number':
				// with JavaScript NaN != NaN so we need a special check
				if (isNaN(first[prop]) && isNaN(second[prop])) {
					break;
				}
			// eslint-disable-next-line no-fallthrough
			default:
				if (first[prop] !== second[prop]) {
					return false;
				}
		}
	}
	return true;
}

export const envKeyEquals = (key, value) => {
	if (Object.prototype.hasOwnProperty.call(process.env, key)) {
		const envKeyValue = process.env[key];
		const valueType = typeof value;
		switch (valueType) {
			case 'boolean':
				return envKeyValue === value.toString();
			case 'number':
				try {
					const numericValue = parseFloat(envKeyValue);
					return numericValue.toString() === value.toString();
				} catch (e) {
					return false;
				}
			case 'object':
				if (value === null) {
					return envKeyValue === 'null';
				} else if (value instanceof RegExp) {
					const lastSlash = envKeyValue.lastIndexOf('/');
					if (lastSlash > -1) {
						const pattern = envKeyValue.substring(1, lastSlash);
						const flags = envKeyValue.substring(lastSlash + 1, envKeyValue.length);
						const envKeyRegExp = new RegExp(pattern, flags);
						return envKeyRegExp.toString() === value.toString();
					}
					return false;
				}

				// assume JSON (works for Arrays as well), return false for anything else
				try {
					const parsedValue = JSON.parse(envKeyValue);
					if (Array.isArray(value) && Array.isArray(parsedValue)) {
						value.sort();
						parsedValue.sort();
					}
					return isDeepEqual(parsedValue, value);
				} catch (e) {
					return false;
				}
			case 'function':
				throw new Error('Unsupported equality match type "function"');
			case 'undefined':
				return envKeyValue === 'undefined' || !envKeyValue;
			default:
				return envKeyValue === value;
		}
	}

	// key does not exist and value is undefined, then return true otherwise false
	return typeof value === 'undefined';
};

/*
 * This exists for the sole purpose of testing
 * To override the "current" date in tests, do something like below
 * ex) jest.spyOn(global.Date, 'now').mockImplementation(() => new Date('2020-01-15T11:01:58.135Z').valueOf());
 */
export function getCurrentDate() {
	return new Date(Date.now());
}

export function isFile(data) {
	if (!data) {
		return false;
	}
	for (const key of Object.keys(data)) {
		const value = data[key];
		if ('File' in window && value instanceof File) {
			return true;
		}
	}
	return false;
}
